// extracted by mini-css-extract-plugin
export default {"container":"SortSales_container__u+psq","title":"SortSales_title__2buRF","price":"SortSales_price__o7NgM","sorted":"SortSales_sorted__QyHKO"};